import EmojiPicker, { IEmojiData } from "emoji-picker-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import Modal from "../Modal";
import { PickerArea } from "./styles";

type Props = {
  onSelect: (data: IEmojiData) => void;
  onCancel: () => void;
};

const prefix = "components.emojiModal";

/** Picks the emoji of a link's or highlight's thumbnail: the picker in the editor's dark theme, a click picks it */
export const EmojiModal = ({ onSelect, onCancel }: Props) => {
  const { t } = useTranslation();
  const groupNames = useMemo(
    () => ({
      smileys_people: t(`${prefix}.groups.people`),
      animals_nature: t(`${prefix}.groups.nature`),
      food_drink: t(`${prefix}.groups.food`),
      travel_places: t(`${prefix}.groups.travel`),
      activities: t(`${prefix}.groups.activities`),
      objects: t(`${prefix}.groups.objects`),
      symbols: t(`${prefix}.groups.symbols`),
      flags: t(`${prefix}.groups.flags`),
      recently_used: t(`${prefix}.groups.recentlyUsed`),
    }),
    [t]
  );

  return (
    <Modal flush outsideExit title={t(`${prefix}.title`)} onExit={onCancel}>
      <PickerArea>
        <EmojiPicker
          disableAutoFocus
          onEmojiClick={(_, data) => onSelect(data)}
          native
          searchPlaceholder={t(`${prefix}.search`)}
          pickerStyle={{ width: "100%", height: "420px", boxShadow: "none" }}
          groupNames={groupNames}
        />
      </PickerArea>
    </Modal>
  );
};
